// 0x18f27  void updatePlayer(void)   [Watcom, no args, no return value]  (code 0x18f27..0x1977d RET)
// No register arguments: after `push 0x24; call __CHK` it pushes EBX/ECX/EDX/ESI/EDI/EBP (`sub esp, 0`: no
// locals) and writes every register before reading it (signatures.json regs 0). Return value: none — EAX at RET
// is a leftover (a load / callee result); both call sites (0x1617b, 0x1d630) are followed directly by calls to
// 0x15788 / 0x16446, which take no register args (signatures.json regs 0), so EAX is not read.
//
// Structures (LIBRARY.md "Structures"):
//   dws_DPLAY (stride 0x20, +0xA soundnum): 0x61300, 0x613e0, 0x611a0, 0x613a0, 0x611c0, 0x611e0, 0x61200,
//     0x61220, 0x61400, 0x61420 are passed to dws_DPlay (LIBRARY.md `dws_DPlay(dws_DPLAY *dp)`); the words
//     read at 0x6130a, 0x613ea, 0x6142a, 0x611aa, 0x613aa, 0x611ca, 0x611ea, 0x6120a, 0x6122a are +0xA of
//     structs at 0x61300, 0x613e0, 0x61420, 0x611a0, 0x613a0, 0x611c0, 0x611e0, 0x61200, 0x61220 and are
//     passed as soundnum to dws_DDiscard / dws_DSoundStatus.
//   0x60f14: the WORD *result of dws_DSoundStatus (LIBRARY.md); read back as a word after each call.
//   0x61668: passed as RGB_color* to Write_Color_Reg (LIBRARY.md: bytes +0, +1, +2 = r, g, b).
//   0x33aa4 / 0x33dbc are sprites (x +0, y +4; evidence in 1977e_sub_1977e.js header).
// All other globals by address only; no game meaning is claimed.
import { F, register } from '../runtime/registry.js';
import { R8, W8, R16, R32, W32 } from '../runtime/mem.js';
import { imod } from '../runtime/cpu.js';
import { BONG_STATE, MISSILE, RASTA, WEAPON } from './states.js';
import { gunSight, jointGlowColor, missile, rasta, sndBong, sndBongBlow, sndBongBubble, sndGetSome, sndGunShot, sndIShot, sndMissile, sndPdie4, sndSmokin, sndYaMon, soundStatus } from './data.js';
import { G, dplay, sprite } from './access.js';

register(0x18f27, 'updatePlayer_18f27', function updatePlayer() {
  // 0x18f3f..0x18f9b
  if ((G.mouseButtons === 1 || G.prevGunSightY !== sprite(gunSight).y || G.prevGunSightX !== sprite(gunSight).x) && // 18f3f..18f62
      (sprite(rasta).state === RASTA.SMOKING || sprite(rasta).state === RASTA.LIGHTING_UP) && // 18f64..18f74
      G.inLevelEndSequence !== 1 && // 18f7a
      sprite(rasta).state !== RASTA.LOADING_BONG && // 18f85
      sprite(rasta).state !== RASTA.BONG_HIT) { // 18f90
    sprite(rasta).state = RASTA.AIMING; // 18f9b
  }

  // 0x18fa5..0x19018
  if (G.mouseButtons !== 1 && G.prevGunSightY === sprite(gunSight).y && G.prevGunSightX === sprite(gunSight).x &&
      sprite(rasta).state === RASTA.AIMING) {
    G.idleTimer = (G.idleTimer - 1) | 0; // 18fd7 dec
    if (G.idleTimer < 0) { // 18fdd cmp 0; jge
      sprite(rasta).state = RASTA.LIGHTING_UP;
      sprite(rasta).currFrame = 0xa;
      G.rastaAnimDelay = 0;
      G.idleTimer = 0x64;
      G.smokeGlowPhase = 2;
    }
  }

  // 0x19018..0x19115
  if (sprite(rasta).state === RASTA.SMOKING) {
    if (G.smokeGlowPhase === 2) {
      G.jointGlowColor = (G.jointGlowColor + 2) & 0xff; // 1902e add byte
      F.Write_Color_Reg_20541(0xb6, jointGlowColor); // 19035..1903f
      if (G.jointGlowColor > 0x3c) { // 19044..1904e movzx; cmp 0x3c; jle
        G.smokeGlowPhase = 0;
      }
    }
    G.rastaAnimDelay = (G.rastaAnimDelay + 1) | 0; // 1905a inc
    if (G.rastaAnimDelay > 4) { // 19060 jle
      if (G.smokeGlowPhase === 0) {
        sprite(rasta).currFrame = (sprite(rasta).currFrame + 1) | 0; // 19076 inc
        if (sprite(rasta).currFrame > 0x12) { // 1907c jle
          G.smokeGlowPhase = 1;
          sprite(rasta).currFrame = 0x12;
          G.jointGlowColor = 4;
          W8((jointGlowColor + 0x1), 2);
          F.Write_Color_Reg_20541(0xb6, jointGlowColor); // 190a7..190b1
          F.dws_DDiscard_1f770(dplay(sndPdie4).soundnum); // 190b6..190bf (cdecl, zero-extended word)
          F.dws_DPlay_1eff8(sndPdie4); // 190c7..190cd (cdecl)
          G.score = (G.score + 0x3e8) | 0; // 190d5
        }
      }
      if (G.smokeGlowPhase === 1) { // 190df
        sprite(rasta).currFrame = (sprite(rasta).currFrame - 1) | 0; // 190e8 dec
        if (sprite(rasta).currFrame < 0x10) { // 190ee jge
          sprite(rasta).currFrame = 0x10;
          G.smokeGlowPhase = 2;
        }
      }
      G.rastaAnimDelay = 0; // 1910b
    }
  }

  // 0x19115..0x1915f
  if (sprite(rasta).state === RASTA.LIGHTING_UP) {
    F.Write_Color_Reg_20541(0xb6, jointGlowColor); // 1911e..19128
    G.rastaAnimDelay = (G.rastaAnimDelay + 1) | 0; // 1912d inc
    if (G.rastaAnimDelay > 4) { // 19133 jle
      sprite(rasta).currFrame = (sprite(rasta).currFrame + 1) | 0; // 1913c inc
      if (sprite(rasta).currFrame > 0xf) { // 19142 jle
        sprite(rasta).state = RASTA.SMOKING;
      }
      G.rastaAnimDelay = 0; // 19155
    }
  }

  // 0x1915f..0x191b2
  if (sprite(rasta).state === RASTA.LOADING_BONG) {
    G.rastaAnimDelay = (G.rastaAnimDelay + 1) | 0; // 19168 inc
    if (G.rastaAnimDelay > 4) { // 1916e jle
      sprite(rasta).currFrame = (sprite(rasta).currFrame + 1) | 0; // 19177 inc
      if (sprite(rasta).currFrame > 0x22) { // 1917d jle
        sprite(rasta).state = RASTA.BONG_HIT;
        G.bongHitTimer = 0x5a;
        F.dws_DPlay_1eff8(sndBongBubble); // 1919a..191a0 (cdecl)
      }
      G.rastaAnimDelay = 0; // 191a8
    }
  }

  // 0x191b2..0x1921d
  if (sprite(rasta).state === RASTA.BONG_HIT) {
    sprite(rasta).currFrame = 0x22; // 191bb
    G.bongHitTimer = (G.bongHitTimer - 1) | 0; // 191c5 dec
    F.dws_DSoundStatus_1f348(dplay(sndBongBubble).soundnum, soundStatus); // 191cb..191da (cdecl, push 0x60f14 then word)
    if (G.soundStatus === 0 || G.bongHitTimer < 0) { // 191e2 je / 191ec jge
      sprite(rasta).state = RASTA.AIMING;
      G.bongState = BONG_STATE.LOADED;
      G.bongShotsLeft = 0x3c;
      G.bongBlowPending = 1;
    }
  }

  // 0x1921d
  if (sprite(rasta).state !== RASTA.AIMING) {
    return; // jne 0x19777 (epilogue)
  }

  F.dws_DSoundStatus_1f348(dplay(sndBong).soundnum, soundStatus); // 1922a..19239 (cdecl)
  if (G.soundStatus !== 0 && G.mouseButtons !== 1) { // 19241 je skip / 1924b jne do
    F.dws_DDiscard_1f770(dplay(sndBong).soundnum); // 19256..1925f
    G.bongBlowPending = 1; // 19267
  }

  // 0x19271..0x192b3
  if (G.currentWeapon === WEAPON.AUTO_GUN || G.currentWeapon === WEAPON.DEFAULT_GUN) {
    sprite(rasta).currFrame = 0;
  }
  if (G.currentWeapon === WEAPON.MISSILE_LAUNCHER) {
    sprite(rasta).currFrame = 0x14;
  }
  if (G.currentWeapon === WEAPON.BONG) {
    sprite(rasta).currFrame = 0x23;
  }

  // 0x192b3..0x19315: 0xbe < 0x33aa4.x + 6 < 0x140
  if (((sprite(gunSight).x + 6) | 0) > 0xbe && ((sprite(gunSight).x + 6) | 0) < 0x140) {
    if (G.currentWeapon === WEAPON.AUTO_GUN || G.currentWeapon === WEAPON.DEFAULT_GUN) {
      sprite(rasta).currFrame = 2;
    }
    if (G.currentWeapon === WEAPON.MISSILE_LAUNCHER) {
      sprite(rasta).currFrame = 0x16;
    }
    if (G.currentWeapon === WEAPON.BONG) {
      sprite(rasta).currFrame = 0x24;
    }
  }

  // 0x19315..0x19374: 0 < 0x33aa4.x + 6 < 0x82
  if (((sprite(gunSight).x + 6) | 0) > 0 && ((sprite(gunSight).x + 6) | 0) < 0x82) {
    if (G.currentWeapon === WEAPON.AUTO_GUN || G.currentWeapon === WEAPON.DEFAULT_GUN) {
      sprite(rasta).currFrame = 4;
    }
    if (G.currentWeapon === WEAPON.MISSILE_LAUNCHER) {
      sprite(rasta).currFrame = 0x18;
    }
    if (G.currentWeapon === WEAPON.BONG) {
      sprite(rasta).currFrame = 0x25;
    }
  }

  // 0x19374..0x193e1: 0x118 < 0x33aa4.x + 6 < 0x140 and 0x33aa4.y > 0x50
  if (((sprite(gunSight).x + 6) | 0) > 0x118 && ((sprite(gunSight).x + 6) | 0) < 0x140 && sprite(gunSight).y > 0x50) {
    if (G.currentWeapon === WEAPON.AUTO_GUN || G.currentWeapon === WEAPON.DEFAULT_GUN) {
      sprite(rasta).currFrame = 6;
    }
    if (G.currentWeapon === WEAPON.MISSILE_LAUNCHER) {
      sprite(rasta).currFrame = 0x1a;
    }
    if (G.currentWeapon === WEAPON.BONG) {
      sprite(rasta).currFrame = 0x26;
    }
  }

  // 0x193e1..0x19449: 0 < 0x33aa4.x + 6 < 0x28 and 0x33aa4.y > 0x50
  if (((sprite(gunSight).x + 6) | 0) > 0 && ((sprite(gunSight).x + 6) | 0) < 0x28 && sprite(gunSight).y > 0x50) {
    if (G.currentWeapon === WEAPON.AUTO_GUN || G.currentWeapon === WEAPON.DEFAULT_GUN) {
      sprite(rasta).currFrame = 8;
    }
    if (G.currentWeapon === WEAPON.MISSILE_LAUNCHER) {
      sprite(rasta).currFrame = 0x1c;
    }
    if (G.currentWeapon === WEAPON.BONG) {
      sprite(rasta).currFrame = 0x27;
    }
  }

  // 0x19449..0x194ad: 0x33aa4.x + 6 > 0x33dbc.x and 0x33aa4.y + 6 > 0x33dbc.y
  if (((sprite(gunSight).x + 6) | 0) > sprite(rasta).x && ((sprite(gunSight).y + 6) | 0) > sprite(rasta).y) {
    if (G.currentWeapon === WEAPON.AUTO_GUN || G.currentWeapon === WEAPON.DEFAULT_GUN) {
      sprite(rasta).currFrame = 6;
    }
    if (G.currentWeapon === WEAPON.MISSILE_LAUNCHER) {
      sprite(rasta).currFrame = 0x1a;
    }
    if (G.currentWeapon === WEAPON.BONG) {
      sprite(rasta).currFrame = 0x26;
    }
  }

  // 0x194ad..0x19511: 0x33aa4.x + 6 < 0x33dbc.x and 0x33aa4.y + 6 > 0x33dbc.y
  if (((sprite(gunSight).x + 6) | 0) < sprite(rasta).x && ((sprite(gunSight).y + 6) | 0) > sprite(rasta).y) {
    if (G.currentWeapon === WEAPON.AUTO_GUN || G.currentWeapon === WEAPON.DEFAULT_GUN) {
      sprite(rasta).currFrame = 8;
    }
    if (G.currentWeapon === WEAPON.MISSILE_LAUNCHER) {
      sprite(rasta).currFrame = 0x1c;
    }
    if (G.currentWeapon === WEAPON.BONG) {
      sprite(rasta).currFrame = 0x27;
    }
  }

  // 0x19511..0x19523
  if (G.mouseButtons !== 1 || G.fireReady !== 1) {
    return; // jmp 0x19777 (epilogue)
  }

  F.dws_DDiscard_1f770(dplay(sndGunShot).soundnum); // 19528..19531
  if (sprite(missile).state === MISSILE.INACTIVE) {
    F.dws_DDiscard_1f770(dplay(sndMissile).soundnum); // 19542..1954b
  }

  if (imod(F.rand_232c7(), 0x1e) === 0xf) { // 19553..19569: cdq-style sar; idiv 30; cmp edx, 15
    G.randomVoice = imod(F.rand_232c7(), 4); // 1956f..19582: idiv 4 -> remainder
    F.dws_DDiscard_1f770(dplay(sndYaMon).soundnum); // 19588..19592
    F.dws_DDiscard_1f770(dplay(sndSmokin).soundnum); // 1959a..195a4
    F.dws_DDiscard_1f770(dplay(sndGetSome).soundnum); // 195ac..195b6
    F.dws_DDiscard_1f770(dplay(sndIShot).soundnum); // 195be..195c8
    if (G.randomVoice === 0) {
      F.dws_DPlay_1eff8(sndYaMon);
    }
    if (G.randomVoice === 1) {
      F.dws_DPlay_1eff8(sndSmokin);
    }
    if (G.randomVoice === 2) {
      F.dws_DPlay_1eff8(sndGetSome);
    }
    if (G.randomVoice === 3) {
      F.dws_DPlay_1eff8(sndIShot);
    }
  } else { // 0x1962e
    if (G.currentWeapon === WEAPON.AUTO_GUN || G.currentWeapon === WEAPON.DEFAULT_GUN) {
      F.dws_DPlay_1eff8(sndGunShot); // 19640..19646
    }
    if (G.currentWeapon === WEAPON.MISSILE_LAUNCHER && sprite(missile).state === MISSILE.INACTIVE) { // 1964e jne skip / 19657 je do
      F.dws_DPlay_1eff8(sndMissile); // 19662..19668
    }
  }

  // 0x19670..0x196bf
  if (G.currentWeapon === WEAPON.AUTO_GUN || G.currentWeapon === WEAPON.DEFAULT_GUN) {
    sprite(rasta).currFrame = (sprite(rasta).currFrame + 1) | 0; // 19682 inc
    F.fireBullet_11c2a(); // 19688
    if (G.currentWeapon === WEAPON.DEFAULT_GUN) {
      G.fireReady = 0; // 19696
    }
  }
  if (G.currentWeapon === WEAPON.MISSILE_LAUNCHER && sprite(missile).state === MISSILE.INACTIVE) { // 196a0 jne skip / 196a9 je do
    sprite(rasta).currFrame = (sprite(rasta).currFrame + 1) | 0; // 196b4 inc
    F.fireMissile_1864d(); // 196ba
  }

  // 0x196bf
  if (G.currentWeapon !== WEAPON.BONG) {
    return; // jne 0x19777 (epilogue)
  }
  if (G.bongState === BONG_STATE.LOADED) { // 196cc
    G.bongShotsLeft = (G.bongShotsLeft - 1) | 0; // 196d9 dec
    if (G.bongShotsLeft > 0) { // 196df jle
      F.fireBongSmoke_1977e(); // 196e8
      if (G.bongBlowPending === 1) {
        F.dws_DPlay_1eff8(sndBongBlow); // 196f6..196fc
        G.bongBlowPending = 0; // 19704
      }
      F.dws_DSoundStatus_1f348(dplay(sndBong).soundnum, soundStatus); // 1970e..1971d
      if (G.soundStatus === 0) { // 19725 jne
        F.dws_DPlay_1eff8(sndBong); // 1972f..19735
      }
    } else { // 0x1973f
      G.bongState = BONG_STATE.NEEDS_RELOAD;
      F.dws_DDiscard_1f770(dplay(sndBong).soundnum); // 19749..19752
    }
  }
  if (G.bongState === BONG_STATE.NEEDS_RELOAD) { // 1975a
    sprite(rasta).state = RASTA.LOADING_BONG;
    sprite(rasta).currFrame = 0x1e;
  }
});
